
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

import { mapMutations, mapState, mapGetters } from "vuex";
export default {
name: "RankPage",
data() {
return {
loading: false,
topList: []
};
},
created: async function() {
try {
this.$store.commit("loadingCtrl", true);
let res = await this.$store.dispatch("getRankList");
let _data = res.data.data;
this.topList = _data.topList;
} catch (error) {
this.$store.commit("notify", { text: "获取数据失败" });
}
this.$store.commit("loadingCtrl", false);
},
methods: {
...mapMutations(["loadingCtrl", "notify"])
},
components: { Flexbox, FlexboxItem, XImg, Group, Cell, CellFormPreview, CellBox }
};



// WEBPACK FOOTER //
// ./src/components/RankPage.vue